import { render } from "./HomeShowcase.vue?vue&type=template&id=34e3c7ed"
import script from "./HomeShowcase.vue?vue&type=script&lang=js"
export * from "./HomeShowcase.vue?vue&type=script&lang=js"

import exportComponent from "E:\\myproject\\vuejs-tailwindcss-portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__